import React from 'react';
import TikTokHero from './Tiktokhero';
import Newsletter from '../Homepage/Newsletter';
import Footer from '../Layouts/Footer';
import TikTokBenefits from './Tiktokbenefits';
import HowItWorks from './Howitworks';
import Canonical from '../../seo/Canonical';
import TikTokLiveFAQs from './TikTokLiveFAQs';

const TikTokLive: React.FC = () => {
  return (
    <div className="tiktok-live-page">
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />
      <TikTokHero />
      <TikTokBenefits/>
      <HowItWorks/>
      <TikTokLiveFAQs />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default TikTokLive;
